import { render, staticRenderFns } from "./manageInfo.vue?vue&type=template&id=1c3df638&scoped=true"
import script from "./manageInfo.vue?vue&type=script&lang=js"
export * from "./manageInfo.vue?vue&type=script&lang=js"
import style0 from "./manageInfo.vue?vue&type=style&index=0&id=1c3df638&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3df638",
  null
  
)

export default component.exports